export class AddressMap {
  userId: number;
  locationCode: string;
  addrType: string;
  addressId: number;
  addrLn1: string;
  addrLn2: string;
  city: string;
  stateCode: string;
  postalCode: number;
  projectName?: string;
  addrName?: string;
}